/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { FileID } from './file-model';

export class CreateFileInput {
	id: FileID = ''

	isFeatured?: boolean
}